import styled from "styled-components/macro";
import { DefaultParagraphLargeFactory, DefaultParagraphMediumFactory, DefaultTitleLargeFactory } from "../core/Typograph/Typograph.Style";

export const Container = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: 40,

    [theme.breakpoint.lg()]: {
        flexDirection: 'row',
        gap: 48
    }
}))

export const Card = styled.div(({ theme }) => ({
    paddingLeft: 16,
    borderLeft: `2px solid ${theme.color.brandPrimary.light}`,
    
    [theme.breakpoint.lg()]: {
        minWidth: '373px'
    }
}))

export const CardHeader = styled.div(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginBottom: 16
}))

export const CardParagraph = styled.p(({ theme, isTradicional }) => ({
    ...(isTradicional 
        ? DefaultParagraphMediumFactory({ theme }) 
        : DefaultParagraphLargeFactory({ theme })
    ),
    fontWeight: 600,
    color: theme.color.neutral['02'].dark
}))

export const Title = styled.h3(({ theme }) => ({
    ...DefaultTitleLargeFactory({ theme }),
    marginBottom: 40,

    [theme.breakpoint.lg()]: {
        marginBottom: 60
    }
}))


